import { useCallback, useRef, useState } from 'react';

export interface UseResizableProps {
  initialWidth: number;
  minWidth: number;
  maxWidth: number;
  resizableSide: 'left' | 'right';
}

export const useResizable = ({
  initialWidth,
  minWidth = 200,
  maxWidth = 800,
  resizableSide = 'right',
}: UseResizableProps) => {
  const [width, setWidth] = useState(initialWidth);
  const [isResizing, setIsResizing] = useState(false);

  const targetRef = useRef<HTMLDivElement>(null);

  const onMouseDown = useCallback(() => {
    setIsResizing(true);
  }, []);

  const onMouseUp = useCallback(() => {
    setIsResizing(false);
  }, []);

  const onMouseMove = useCallback(
    (e: MouseEvent) => {
      if (isResizing && targetRef?.current) {
        setWidth(
          Math.max(
            minWidth,
            Math.min(
              maxWidth,
              resizableSide === 'right'
                ? e.clientX - targetRef.current.getBoundingClientRect().left
                : targetRef.current.getBoundingClientRect().right - e.clientX
            )
          )
        );
      }
    },
    [isResizing, maxWidth, minWidth, resizableSide]
  );

  return {
    width,
    isResizing,
    targetRef,
    onMouseDown,
    onMouseUp,
    onMouseMove,
    setWidth,
  };
};
